import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const AlphaNumericInput = ({
    label = "String",
    placeholder = "Enter string",
    required = false,
    layout = "below",
    value = "", // Value from formik
    name = "alphanumeric",
    id = "alphaNumericInput",
    onChange = () => { },
    onBlur = () => { },
    requiredErrorMessage = "This field is required.",
    validationErrorMessage = "Only letters and numbers are allowed.",
    minLengthErrorMessage = "Input must be at least 3 characters.",
    showHelp = false,
    helpText = null,
    validateTrigger // New prop to trigger validation from parent
}) => {
    const [inputValue, setInputValue] = useState(value); // Local state for input value
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    // Effect to update inputValue when value prop changes (useful for 'edit mode')
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    // Validation function to check if input is valid
    // Validation function to check if input is valid
const validateInput = (value) => {
    const newErrors = {};
    
    if (required && !value) {
        newErrors.required = requiredErrorMessage;
    } else if (value && value.length < 3) {
        newErrors.minLength = minLengthErrorMessage;
    } else if (value && !/^[A-Za-z0-9 ]+$/.test(value)) { // Updated regex to allow spaces
        newErrors.validation = validationErrorMessage;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
};


    // On change handler that validates input
    const handleInputChange = (e) => {
        const { value: newValue } = e.target;
        setInputValue(newValue);  // Update local state
        onChange(e);  // Call formik's onChange
    };

    // On blur, validate the input
    const handleInputBlur = (e) => {
        validateInput(e.target.value);
        onBlur(e);  // Call formik's onBlur
    };

    // Trigger validation when validateTrigger changes
    useEffect(() => {
        if (validateTrigger) {
            validateInput(inputValue);
        }
    }, [validateTrigger]);

    return (
        <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
               <span> {label}
                {required && <span className="text-danger ml-1">*</span>}
                </span>
                {showHelp && helpText && (
                    <span id="helpTooltip" className="px-2">
                        <i
                            className="ri-question-line"
                            style={{ cursor: 'pointer', fontSize: '16px' }}
                        ></i>
                    </span>
                )}
            </label>
            {showHelp && helpText && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <Input
                    type="text"
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    value={inputValue} // Use inputValue, which is synced with value prop
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    invalid={!!errors.required || !!errors.validation || !!errors.minLength}
                />
                {errors.required && (
                    <FormFeedback type="invalid">
                        {errors.required}
                    </FormFeedback>
                )}
                {errors.minLength && (
                    <FormFeedback type="invalid">
                        {errors.minLength}
                    </FormFeedback>
                )}
                {errors.validation && (
                    <FormFeedback type="invalid">
                        {errors.validation}
                    </FormFeedback>
                )}
            </div>
        </div>
    );
};

export default AlphaNumericInput;
